import Reveal from "@/components/Reveal";
import { useSeo } from "@/lib/seo";

export default function MentionsLegales() {
  useSeo({
    title: "Mentions légales — Gambit Immobilier",
    description:
      "Mentions légales de Gambit Immobilier : éditeur, hébergement, propriété intellectuelle et droit applicable.",
    path: "/mentions-legales",
  });
  return (
    <div data-testid="page-mentions-legales" className="bg-cream">
      <section className="mx-auto max-w-[1400px] px-6 pb-12 pt-16 md:px-12 md:pb-16 md:pt-24 lg:px-16">
        <Reveal>
          <p className="kicker mb-8 md:mb-10">Conformité</p>
          <h1 className="text-display text-[clamp(2.25rem,5vw,4rem)] text-ink">
            Mentions <span className="text-gold">légales.</span>
          </h1>
        </Reveal>
      </section>

      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="hairline" />
      </div>

      <section className="mx-auto max-w-[1400px] px-6 py-16 md:px-12 md:py-24 lg:px-16">
        <div className="mx-auto max-w-3xl space-y-14 font-serif text-[1.0625rem] leading-[1.75] text-ink/85 md:text-[1.125rem]">

          <Reveal>
            <h2 className="kicker mb-4">Éditeur du site</h2>
            <p>
              Gambit Immobilier<br />
              SASU à capital variable<br />
              Farid Amadet, Président<br />
              552 avenue de la Plage, 40440 Ondres<br />
              07 75 71 39 78<br />
              f.amadet@gambit-immo.fr
            </p>
            <p className="mt-4 text-[0.9375rem] text-ink/60">
              SIREN : 104 299 409<br />
              RCS Dax : 104 299 409<br />
              TVA intracommunautaire : FR04104299409
            </p>
          </Reveal>

          <Reveal>
            <h2 className="kicker mb-4">Directeur de la publication</h2>
            <p>Farid Amadet, en qualité de Président.</p>
          </Reveal>

          <Reveal>
            <h2 className="kicker mb-4">Hébergement</h2>
            <p>
              Emergent Labs Inc.<br />
              2380 Via Espada, Pleasanton, Californie, États-Unis<br />
              emergent.sh
            </p>
          </Reveal>

          <Reveal>
            <h2 className="kicker mb-4">Propriété intellectuelle</h2>
            <p>
              L'ensemble des éléments du site (textes, marques, logo, images,
              graphismes, mise en forme) est protégé au titre du droit d'auteur
              et du droit des marques. Toute reproduction, représentation,
              modification ou exploitation, totale ou partielle, sans
              autorisation écrite préalable est interdite.
            </p>
          </Reveal>

          <Reveal>
            <h2 className="kicker mb-4">Responsabilité</h2>
            <p>
              Les informations diffusées sur ce site sont fournies à titre
              indicatif. L'éditeur s'efforce d'en assurer l'exactitude et la
              mise à jour, sans pouvoir en garantir l'exhaustivité ou l'absence
              d'erreurs. La responsabilité de l'éditeur ne saurait être engagée
              en cas d'inexactitude ou d'omission portant sur ces informations,
              ni pour les dommages résultant d'une intrusion frauduleuse d'un
              tiers.
            </p>
          </Reveal>

          <Reveal>
            <h2 className="kicker mb-4">Droit applicable</h2>
            <p>
              Le présent site est soumis au droit français. En cas de litige,
              les juridictions françaises seront seules compétentes.
            </p>
          </Reveal>

          <Reveal>
            <p className="text-[0.9375rem] text-ink/55">Dernière mise à jour : 2026.</p>
          </Reveal>

        </div>
      </section>
    </div>
  );
}
